import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { List, Switch, notification } from 'antd';
import { MUTATION_SET_CORPORATE_CLIENT_CUSTOM_REPORTS } from '../../../../queries/CorporateClientsQueries';
import { CUSTOM_REPORTS } from '../../../../constants/customReports';
import { GeneralTabProps } from '../utils/corpClientTypes';

const CustomReportsTab: React.FC<GeneralTabProps> = ({
  corpClientData,
  refetch,
}) => {
  const corpClient = corpClientData?.getCorporateClient;
  const enabledKeys = corpClient?.config_parsed?.custom_reports ?? [];
  const [savingKey, setSavingKey] = useState<string | null>(null);
  const [setCustomReports] = useMutation(
    MUTATION_SET_CORPORATE_CLIENT_CUSTOM_REPORTS,
  );

  const toggleReport = async (reportKey: string, checked: boolean) => {
    setSavingKey(reportKey);

    try {
      const { data } = await setCustomReports({
        variables: {
          corporate_client_id: corpClient?.corporate_client_id,
          custom_reports: checked
            ? [...enabledKeys, reportKey]
            : enabledKeys.filter((key) => key !== reportKey),
        },
      });
      const result = data.setCorporateClientCustomReports;

      if (!result.success) {
        throw new Error(result.error_message?.message);
      }

      await refetch?.();
    } catch (error) {
      notification.error({
        message: 'Error',
        description: (error as Error).message,
      });
    } finally {
      setSavingKey(null);
    }
  };

  return (
    <List
      style={{ maxWidth: 768 }}
      dataSource={Object.entries(CUSTOM_REPORTS)}
      renderItem={([reportKey, report]) => (
        <List.Item
          actions={[
            <Switch
              key={reportKey}
              aria-label={report.label}
              checked={enabledKeys.includes(reportKey)}
              loading={savingKey === reportKey}
              disabled={savingKey !== null}
              onChange={(checked) => toggleReport(reportKey, checked)}
            />,
          ]}
        >
          <List.Item.Meta
            title={report.label}
            description={report.description}
          />
        </List.Item>
      )}
    />
  );
};

export default CustomReportsTab;
